module.exports = __webpack_public_path__ + "static/bg02-c4f63781101876ef595ffdf34c7d38a7.webp";